import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSchoolFilters } from './SchoolLayout'

const DateRangeBar: React.FC<{
  classes?: Array<{ id: number; name: string }>
  showClassFilter?: boolean
}> = ({ classes = [], showClassFilter = true }) => {
  const { t } = useTranslation('school')
  const { filters, setFilters } = useSchoolFilters()

  const presets = ['last7', 'last30', 'semester', 'academicYear'] as const

  return (
    <div className="bg-white border border-gray-200 rounded-lg p-4 flex flex-wrap gap-3 items-end">
      <div>
        <label className="block text-xs font-medium text-gray-500 mb-1">{t('filters.period')}</label>
        <select
          value={filters.preset}
          onChange={(e) => setFilters((f) => ({ ...f, preset: e.target.value }))}
          className="px-3 py-2 border border-gray-300 rounded-lg text-sm"
        >
          {presets.map((p) => (
            <option key={p} value={p}>{t(`ranges.${p}`)}</option>
          ))}
          <option value="custom">{t('ranges.custom')}</option>
        </select>
      </div>
      {filters.preset === 'custom' && (
        <>
          <div>
            <label className="block text-xs font-medium text-gray-500 mb-1">{t('filters.from')}</label>
            <input
              type="date"
              value={filters.dateFrom || ''}
              onChange={(e) => setFilters((f) => ({ ...f, dateFrom: e.target.value }))}
              className="px-3 py-2 border border-gray-300 rounded-lg text-sm"
            />
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-500 mb-1">{t('filters.to')}</label>
            <input
              type="date"
              value={filters.dateTo || ''}
              onChange={(e) => setFilters((f) => ({ ...f, dateTo: e.target.value }))}
              className="px-3 py-2 border border-gray-300 rounded-lg text-sm"
            />
          </div>
        </>
      )}
      {showClassFilter && (
        <div>
          <label className="block text-xs font-medium text-gray-500 mb-1">{t('filters.class')}</label>
          <select
            value={filters.projectId ?? ''}
            onChange={(e) => setFilters((f) => ({
              ...f,
              projectId: e.target.value ? Number(e.target.value) : null,
            }))}
            className="px-3 py-2 border border-gray-300 rounded-lg text-sm min-w-[160px]"
          >
            <option value="">{t('filters.allClasses')}</option>
            {classes.map((c) => (
              <option key={c.id} value={c.id}>{c.name}</option>
            ))}
          </select>
        </div>
      )}
    </div>
  )
}

export default DateRangeBar
